import { Cpu, CalendarClock, HandshakeIcon } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export type LearningStep = {
  key: string;
  title: string;
  description: string;
  helper: string;
  Icon: LucideIcon;
  accent: string;
  examples: string[];
};

export const LEARNING_STEPS: LearningStep[] = [
  {
    key: "core-memories",
    title: "Core Memories",
    description:
      "These files shape your bot's personality, what it understands about your household, and how it should work with you.",
    helper:
      "Take a peek to see what your agent is thinking or edit them to train Faye on your preferences, add context, or instruct your agent how to get things done.",
    Icon: Cpu,
    accent: "#DDF1EC",
    examples: [
      "The best time to get my attention is between 7-9pm, remind me then!",
      "My love language is checklists and spreadsheets",
      "Big family trip this summer - everything is building up to that!",
      "I'm a morning person, don't schedule anything after 8pm",
      "The kids have soccer on Tuesdays and Thursdays and get home late",
    ],
  },
  {
    key: "dynamic-reminders",
    title: "Routines",
    description:
      "These are the actions or reminders your bot plans to wake up and do on its own, without waiting for a new prompt every time.",
    helper:
      "Simply ask in your chat to add or edit these. Faye can turn natural requests into follow-ups, reminders, and recurring actions.",
    Icon: CalendarClock,
    accent: "#E9F3FB",
    examples: [
      "Remind me to book Yosemite campsite when reservations open for the fall",
      "On Sundays, check the weather — if rain is coming, remind me to turn off the sprinklers",
      "Don't tell him I told you, but remind my husband about the school recital a few days before",
      "Every Friday, nudge me to prep for next week by sending me a draft of a meal plan",
      "When airfare to Hawaii drops below $400, let me know",
    ],
  },
  {
    key: "delegations",
    title: "Helping Hands",
    description:
      "When your bot needs human help, you can delegate tasks to Faye's human Advisors to complete work for you!",
    helper:
      "Think of this as the handoff layer for tasks that need a phone call, extra judgment, or work your agent cannot do alone. We will always ask for your confirmation before passing any of your details to a Faye advisor.",
    Icon: HandshakeIcon,
    accent: "#F7EBDD",
    examples: [
      "Book the campsite using my card on file",
      "Call the vet and refill our pet's prescription",
      "Call the cable company and negotiate a better rate for me",
      "Schedule a plumber for next week and find the best quote",
      "Return this package — here's the tracking number",
      "Get quotes to see if we can get a better rate on our home / auto policies",
    ],
  },
];
